import { c as _c } from "react/compiler-runtime";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { formatApprovalCountdownTime } from "@/helpers/waves/approve-wave.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useApprovalDropStatus } from "@/hooks/waves/useApprovalDropStatus";
interface WaveLeaderboardGalleryItemVotesProps {
  readonly drop: ExtendedDrop;
  readonly variant?: "default" | "subtle" | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function WaveLeaderboardGalleryItemVotes(t0) {
  const $ = _c(32);
  const {
    drop,
    variant: t1,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const displayWinningThreshold = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0 ? winningThreshold : null;
  let t3;
  if ($[0] !== displayWinningThreshold || $[1] !== drop || $[2] !== isVotingClosed || $[3] !== winningThresholdMinDurationMs) {
    t3 = {
      drop,
      isClosed: isVotingClosed,
      winningThreshold: displayWinningThreshold,
      winningThresholdMinDurationMs
    };
    $[0] = displayWinningThreshold;
    $[1] = drop;
    $[2] = isVotingClosed;
    $[3] = winningThresholdMinDurationMs;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const approvalStatus = useApprovalDropStatus(t3);
  const current = approvalStatus.current;
  const isPositive = current >= 0;
  let t4;
  if ($[5] !== isPositive || $[6] !== variant) {
    t4 = () => {
      if (variant === "subtle") {
        return "tw-text-iron-200";
      }
      return isPositive ? "tw-text-emerald-500" : "tw-text-rose-500";
    };
    $[5] = isPositive;
    $[6] = variant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getColorClass = t4;
  let t5;
  bb0: {
    if (displayWinningThreshold === null) {
      t5 = null;
      break bb0;
    }
    if (approvalStatus.kind === "approved") {
      t5 = "Approved";
      break bb0;
    }
    if (approvalStatus.kind === "approving") {
      const t6 = approvalStatus.countdownMs ?? 0;
      let t7;
      if ($[8] !== t6) {
        t7 = formatApprovalCountdownTime(t6);
        $[8] = t6;
        $[9] = t7;
      } else {
        t7 = $[9];
      }
      t5 = `Approving in ${t7}`;
      break bb0;
    }
    if (approvalStatus.kind === "reached_threshold") {
      t5 = "Reached threshold";
      break bb0;
    }
    if (approvalStatus.kind === "closed") {
      t5 = "Closed";
      break bb0;
    }
    const t6 = approvalStatus.remaining ?? 0;
    let t7;
    if ($[10] !== t6) {
      t7 = formatNumberWithCommas(t6);
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t5 = `Needs ${t7}`;
  }
  const approvalStatusLabel = t5;
  let t6;
  bb1: {
    if (approvalStatus.kind === "approved" || approvalStatus.kind === "approving" || approvalStatus.kind === "reached_threshold") {
      t6 = "tw-text-emerald-400";
      break bb1;
    }
    if (approvalStatus.kind === "closed") {
      t6 = "tw-text-amber-300";
      break bb1;
    }
    t6 = variant === "subtle" ? "tw-text-iron-400" : "tw-text-iron-300";
  }
  const approvalStatusClass = t6;
  const t7 = `tw-font-mono tw-text-sm tw-font-bold ${getColorClass()}`;
  let t8;
  if ($[12] !== current) {
    t8 = formatNumberWithCommas(current);
    $[12] = current;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <span className={t7}>{t8}</span>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== displayWinningThreshold) {
    t10 = displayWinningThreshold !== null ? <><span className="tw-font-mono tw-text-sm tw-font-bold tw-text-iron-500">/</span><span className="tw-font-mono tw-text-sm tw-font-bold tw-text-iron-200">{formatNumberWithCommas(displayWinningThreshold)}</span></> : null;
    $[17] = displayWinningThreshold;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = displayWinningThreshold !== null ? drop.realtime_rating : drop.rating_prediction;
  const t12 = displayWinningThreshold !== null ? "Realtime votes given" : undefined;
  const t13 = variant === "subtle";
  let t14;
  if ($[19] !== current || $[20] !== t11 || $[21] !== t12 || $[22] !== t13) {
    t14 = <DropVoteProgressing current={current} projected={t11} tooltipLabel={t12} subtle={t13} />;
    $[19] = current;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== approvalStatusClass || $[25] !== approvalStatusLabel) {
    t15 = approvalStatusLabel !== null ? <span className={`tw-whitespace-nowrap tw-text-xs tw-font-medium ${approvalStatusClass}`}>{approvalStatusLabel}</span> : null;
    $[24] = approvalStatusClass;
    $[25] = approvalStatusLabel;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t14 || $[29] !== t15 || $[30] !== t9) {
    t16 = <div className="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">{t9}{t10}{t14}{t15}</div>;
    $[27] = t10;
    $[28] = t14;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}